import createGlobalState from "@ui/lib/createGlobalState";
import * as io from "io-ts";

export const useQuantitySelectorShowDescriptions = createGlobalState({
  storage: "session",
  key: "quantitySelectorShowDescriptions",
  type: io.boolean,
  defaultValue: false,
  scoped: true,
});
